<template>
  <div>
    <div class="table-ui-detail">
      <table>
        <thead>
          <tr>
            <th width="2%" class="ts-text-center">{{ $t('no') }}</th>
            <th width="15%">{{ $t('promotion.product') }}</th>
            <th width="9%">{{ $t('promotion.rangeType') }}</th>
            <th width="9%">{{ $t('promotion.sign') }}</th>
            <th width="9%">{{ $t('promotion.from') }}</th>
            <th width="9%">{{ $t('promotion.to') }}</th>
            <th width="9%">{{ $t('promotion.discountType') }}</th>
            <th width="9%">{{ $t('promotion.discountRate') }}</th>
            <th width="3%" class="ts-text-center">
              <a href="#" @click.prevent="addItem">
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="model.condition.length == 0">
            <td colspan="12" class="ts-text-center ts-p-3 ts-space-x-1">
              <i class="fa fa-folder-open ts-text-gray-200"></i>
              <label class="ts-text-gray-400">
                {{ $t('noData') }}
              </label>
            </td>
          </tr>
          <tr v-for="(item, index) in model.condition" :key="index">
            <td class="ts-whitespace-no-wrap ts-text-center">
              {{ index + 1 }}
            </td>
            <td class="ts-overflow-hidden ts-whitespace-no-wrap">
              <p class="ts-mb-0">{{ getProductName(item.pro_sale_code_id) }}</p>
              <div
                class="validate ts-text-xs"
                v-if="errors.has('condition.' + index + '.pro_sale_code_id')"
              >
                {{ errors.first('condition.' + index + '.pro_sale_code_id') }}
              </div>
            </td>
            <td>
              <a-select
                v-model="item.range_type"
                class="ts-w-full"
                style="min-width: 50px"
                @change="rangeTypeChange(item)"
              >
                <a-select-option :value="1">Quantity</a-select-option>
                <a-select-option :value="2">Amount</a-select-option>
              </a-select>
              <div
                class="validate ts-text-xs"
                v-if="errors.has('condition.' + index + '.range_type')"
              >
                {{ errors.first('condition.' + index + '.range_type') }}
              </div>
            </td>
            <td>
              <a-select
                v-model="item.operator_sign"
                class="ts-w-full"
                style="min-width: 50px"
                @change="operatorChange(item)"
              >
                <a-select-option value="=">Equal</a-select-option>
                <a-select-option value="between">Between</a-select-option>
                <a-select-option value=">=">Greater or equal</a-select-option>
              </a-select>
              <div
                class="validate ts-text-xs"
                v-if="errors.has('condition.' + index + '.operator_sign')"
              >
                {{ errors.first('condition.' + index + '.operator_sign') }}
              </div>
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              <input
                v-if="item.range_type == 1"
                ref="quantityFrom"
                type="number"
                v-model.number="item.input_amount_from"
                class="form-control"
                @change="onChangeItem(item)"
              />
              <ts-currency-converter-input
                v-else
                :input_amount.sync="item.input_amount_from"
                :amount.sync="item.amount_from"
                :input_currency_id.sync="item.input_currency_id"
                :currency_id.sync="item.currency_id"
                :fx_rate.sync="item.fx_rate"
                :fx_rate_ratio.sync="item.fx_rate_ratio"
                style="min-width: 60px;"
              />
              <div
                class="validate ts-text-xs"
                v-if="errors.has('condition.' + index + '.input_amount_from')"
              >
                {{ errors.first('condition.' + index + '.input_amount_from') }}
              </div>
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              <input
                v-if="item.range_type == 1"
                ref="quantityTo"
                type="number"
                v-model.number="item.input_amount_to"
                class="form-control"
                @change="onChangeItem(item)"
                :disabled="item.operator_sign != 'between'"
              />
              <ts-currency-converter-input
                v-else
                :input_amount.sync="item.input_amount_to"
                :amount.sync="item.amount_to"
                :input_currency_id.sync="item.input_currency_id"
                :currency_id.sync="item.currency_id"
                :fx_rate.sync="item.fx_rate"
                :fx_rate_ratio.sync="item.fx_rate_ratio"
                style="min-width: 60px;"
                :disabled="item.operator_sign != 'between'"
              />
              <div
                class="validate ts-text-xs"
                v-if="errors.has('condition.' + index + '.input_amount_to')"
              >
                {{ errors.first('condition.' + index + '.input_amount_to') }}
              </div>
            </td>
            <td>
              <a-select
                v-model="item.discount_type"
                class="ts-w-full"
                style="min-width: 50px"
                @change="onChangeItem(item)"
              >
                <a-select-option value="%">%</a-select-option>
                <a-select-option
                  :value="getDiscountCurrency(item.input_currency_id)"
                >
                  {{ getDiscountCurrency(item.input_currency_id) }}
                </a-select-option>
              </a-select>
              <div
                class="validate ts-text-xs"
                v-if="errors.has('condition.' + index + '.discount_type')"
              >
                {{ errors.first('condition.' + index + '.discount_type') }}
              </div>
            </td>
            <td>
              <input
                v-if="item.discount_type == '%'"
                ref="discountRate"
                type="number"
                v-model.number="item.input_discount_rate"
                class="form-control"
                @change="onChangeItem(item)"
              />
              <ts-currency-converter-input
                v-else
                :input_amount.sync="item.input_discount_rate"
                :amount.sync="item.discount_rate"
                :input_currency_id.sync="item.input_currency_id"
                :currency_id.sync="item.currency_id"
                :fx_rate.sync="item.fx_rate"
                :fx_rate_ratio.sync="item.fx_rate_ratio"
                style="min-width: 120px;"
              />
              <div
                class="validate ts-text-xs"
                v-if="errors.has('condition.' + index + '.input_discount_rate')"
              >
                {{ errors.first('condition.' + index + '.input_discount_rate') }}
              </div>
            </td>
            <td class="text-center">
              <a
                href="#"
                class="ts-text-red-700 hover:ts-text-red-700"
                @click.prevent="removeItem(index)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- show product list pop-up -->
    <a-modal
      v-if="show_form"
      v-model="show_form"
      :title="$t('promotion.buyProduct')"
      :maskClosable="false"
      :footer="null"
    >
      <ProductList v-model="model" />
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductList from './product-list.vue'
export default {
  name: 'byProduct',
  props: ['value', 'validate'],
  components: {
    ProductList
  },
  data() {
    return {
      errors: new Errors(),
      show_form: false,
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapGetters('promotion/resource', ['getProductName']),
    ...mapState('promotion/discountByRange', ['formViewDatas'])
  },
  methods: {
    addItem() {
      this.show_form = true
    },
    removeItem(index) {
      this.model.condition.splice(index, 1)
    },
    getDiscountCurrency(input_currency_id) {
      if (this.formViewDatas['currency']) {
        return this.formViewDatas['currency'].find(
          el => el.currency_id == input_currency_id
        ).currency_symbol
      }
      return null
    },
    operatorChange(row) {
      if (row.operator_sign != 'between') {
        row.amount_to = null
        row.input_amount_to = null
      }
    },
    rangeTypeChange(row) {
      if (row.operator_sign != 'between') {
        row.amount_to = null
        row.input_amount_to = null
      }
    },
    onChangeItem(product) {
      if (product.discount_type == '%') {
        product.discount_rate = product.input_discount_rate
      } else {
        product.discount_type = this.getDiscountCurrency(
          product.input_currency_id
        )
        product.discount_rate =
          product.input_discount_rate * product.fx_rate_ratio
      }
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
